
import store from '@/store'
import queryApi from "@/utils/request";
const tokenKey = 'TOKEN';
const userKey = "userInfo";
const menuKey = "munes";
const buttonKey = "buttons";
const currentMenuKey = "CURRENT_MENU";
const TOKEN_KEY = "Authorization";
const TOKEN_PRIFIX = "";//"Bearer "

let previewUrl = process.env.VUE_APP_FILE_PREVIEW_ADDR;

export const getTokenParam = (key = TOKEN_KEY) => {
  const token = getToken();
  if (!token) {
    return null;
  }
  return key + '=' + token;
}

export const getTokenHeader = (headers = {}, key = TOKEN_KEY, prefix = TOKEN_PRIFIX) => {
  const token = getToken();
  if (!token) {
    return headers;
  }
  headers[key] = prefix + token;
  return headers;
}

export const getToken = () => {
  return sessionStorage.getItem(tokenKey)
}

export const setToken = (token) => {
  return sessionStorage.setItem(tokenKey, token)
}

export const removeToken = () => {
  return sessionStorage.removeItem(tokenKey)
}

export const getUser = () => {
  let user = sessionStorage.getItem(userKey);
  if (!user) {
    return null;
  }
  return JSON.parse(user);
}

export const setUser = (user) => {
  store.commit('setUser', user);
  return sessionStorage.setItem(userKey, JSON.stringify(user))
}

export const setUpcUser = (res) => {
  let user = {};
  user.sid = res.sid;
  user.loginId = res.upcUserId;
  user.userName = res.userNameCn;
  user.mobile = res.mobilePhone;
  user.compCode = res.companyCode;
  user.compName = res.companyName;
  user.attrs = res.spreadMap || {};
  user.orgId = res.upcUserDeptId;
  user.orgCode = res.upcUserDeptId;
  user.orgName = res.orgShortName;
  user.username = res.userNameCn;
  user.userId = res.upcUserId;
  user.crewShiftEnabled = res.crewShiftEnabled;
	user.upcUserShiftId = res.upcUserShiftId;
	user.upcUserGroupId = res.upcUserGroupId;
  user.orgFullName = res.orgFullName;
  user.photoPath = res.photoPath;
  if(user.photoPath){
    user.photoPath = previewUrl + user.photoPath;
  }
  store.commit('setUser', user);
  return sessionStorage.setItem(userKey, JSON.stringify(user))
}

export const removeUser = () => {
  return sessionStorage.removeItem(userKey)
}

export const getMenu = () => {
  let menu = sessionStorage.getItem(menuKey);
  if (!menu) {
    return null;
  }
  return JSON.parse(menu);
}

export const setMenu = (menu) => {
  return sessionStorage.setItem(menuKey, JSON.stringify(menu))
}

export const removeMenu = () => {
  return sessionStorage.removeItem(menuKey)
}

export const getCurrentMenu = () => {
  return sessionStorage.getItem(currentMenuKey);
}

export const setCurrentMenu = (menu) => {
  return sessionStorage.setItem(currentMenuKey, menu)
}

export const removeCurrentMenu = () => {
  return sessionStorage.removeItem(currentMenuKey)
}

export const getButtons = () => {
  let buttons = sessionStorage.getItem(buttonKey);
  if (!buttons) {
    return null;
  }
  return JSON.parse(buttons);
}

export const loadButtons = () => {
  return queryApi({
    url: '/ac/resource/findPermissionButtonCodes',
    data: {
      appCode: process.env.VUE_APP_CODE
    }
  }, "post").then(res => {
    console.log("Buttons ==> ", res);
    sessionStorage.setItem(buttonKey, JSON.stringify(res || []))
  })
}

export const removeButtons = () => {
  return sessionStorage.removeItem(buttonKey)
}